import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Button, Typography, Box } from "@mui/material";
import { apiClient } from "@/api/apiClient";
import { auth } from "@/config/firebase";

function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  const currentUser = auth.currentUser;
  console.log("RootErrorBoundary", error.stack, error.originalStack);
  
  // Check if this is an authentication-related error
  if (error.message?.includes("useAuth must be used within an AuthProvider") || 
      error.message?.includes("User not found")) {
    // Redirect to login for auth errors
    window.location.href = "/not-found";
    return null;
  }
  
  apiClient.shared.sendSlackErrorBoundaryAlert(
    currentUser?.uid || null,
    location.pathname,
    error.message,
    error.stack || null,
    error.originalStack || null
  );

  return (
    <Box
      role="alert"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      padding={2}
      textAlign="center"
    >
      <Typography variant="h4" color="error" gutterBottom>
        Something went wrong.
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        {error.message}
      </Typography>
      <Button variant="contained" color="primary" onClick={resetErrorBoundary}>
        Try again
      </Button>
    </Box>
  );
}

const RootErrorBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
      {children}
    </ErrorBoundary>
  );
};

export default RootErrorBoundary;
